import React from "react";
import { Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const PricingPageHeader: React.FC = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/accounts", { replace: true });
  };
  return (
    <div className="dashboard-page-title">
      <Button
        onClick={handleBack}
        type="text"
        size="middle"
        icon={<ArrowLeftOutlined style={{ fontSize: "20px" }} />}
      />

      <Typography.Title level={4} style={{ margin: 0 }}>
        Pricing
      </Typography.Title>
    </div>
  );
};

export default PricingPageHeader;
